import { Component, OnInit } from '@angular/core';
import { EmailUpdateConfirmationToken } from 'src/app/core/models/EmailUpdateConfirmationToken';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-verify-link-sent',
  templateUrl: './verify-link-sent.component.html',
  styleUrls: ['./verify-link-sent.component.scss']
})
export class VerifyLinkSentComponent implements OnInit {

  emailVerifyData: EmailUpdateConfirmationToken = null;

  constructor(
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.emailVerifyData = history?.state?.emailVerifyData ?? null;
  }

  navigateBackToHome() {
    this.navigationService.navigateMerchantLanding();
  }
}
